import React from 'react';
import { Modal, Frame } from '@kajabi/sage-react';

import ApplyButton from 'common/components/CopyMagic/components/ApplyButton';
import GenerateButton from 'common/components/CopyMagic/components/GenerateButton';
import { useResultContext, useUiResourceContext } from 'common/components/CopyMagic/contexts';

const FooterActions = () => {
  const { loading } = useUiResourceContext();
  const { result } = useResultContext();

  if (loading || !result) {
    return (
      <Modal.Footer>
        <GenerateButton fullWidth />
      </Modal.Footer>
    );
  }

  return (
    <Modal.Footer>
      <Frame direction={Frame.DIRECTIONS.HORIZONTAL} gap={Frame.GAPS.SM} width={Frame.WIDTHS.FILL}>
        <Frame width_ratio="1">
          <GenerateButton tryAgain fullWidth />
        </Frame>
        <Frame width_ratio="1">
          <ApplyButton fullWidth />
        </Frame>
      </Frame>
    </Modal.Footer>
  );
};

export default FooterActions;
